import { Component, OnInit } from '@angular/core';
import { DataSharingService } from '../services/data-sharing.service';

@Component({
  selector: 'register-progress',
  templateUrl: './register-progress.component.html',
  styleUrls: ['./register-progress.component.css']
})
export class RegisterProgressComponent implements OnInit {
  
  constructor(private _dataSerivce: DataSharingService) { }

  step1Class: string = '';
  step2Class: string = '';
  step3Class: string = '';
  step4Class: string = '';

  getRegisterProgress() {
    console.log('getting register progress...');
    let step = window.sessionStorage.getItem('registerProgress');

    if (step) {
      switch (step) {
        case '1':
          this.step1Class = 'active';
          this.step2Class = '';
          this.step3Class = '';
          this.step4Class = '';
          break;

        case '2':
          this.step1Class = 'active';
          this.step2Class = 'active';
          this.step3Class = '';
          this.step4Class = '';
          break;

        case '3':
          this.step1Class = 'active';
          this.step2Class = 'active';
          this.step3Class = 'active';
          this.step4Class = '';
          break;

        case '4':
          this.step1Class = 'active';
          this.step2Class = 'active';
          this.step3Class = 'active';
          this.step4Class = 'active';
          break;

        default:
          this.step1Class = 'active';
          this.step2Class = '';
          this.step3Class = '';
          this.step4Class = '';
          break;
      }
    }
  }

  ngOnInit() {
    this.getRegisterProgress();
  }
}



// WEBPACK FOOTER //
// ./src/app/register-progress/register-progress.component.ts